
/*
 Add the given password into the list of passwords
 stored in the Cookies.
 */
exports.addStoryPassword = function (cookies, newPassword) {
  const currentPasswords = cookies.get('storyPasswords')

  let secure = true
  if (process.env.NODE_ENV === 'development') {
    secure = false
  }
  if (!currentPasswords) {
    const passwords = [newPassword]
    cookies.set('storyPasswords', JSON.stringify(passwords), '5y', null, null, secure, 'Lax')
  } else {
    // We have some already
    const passwords = JSON.parse(currentPasswords)
    if (!passwords.includes(newPassword)) {
      const newLength = passwords.push(newPassword)
      if (newLength > 25) {
        passwords.shift()
      }
      // Now store the new cookie
      cookies.set('storyPasswords', JSON.stringify(passwords), '5y', null, null, secure, 'Lax')
    }
  }
}
